import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComponentImageDisplayComponent } from './component-image-display/component-image-display.component';

@Component({
  selector: 'app-component-image-history',
  templateUrl: './component-image-history.component.html',
  styleUrls: ['./component-image-history.component.scss']
})
export class ComponentImageHistoryComponent implements OnInit {

  equipmentId: number;
  compartTypeId: number;
  side: number;
  pos: number;
  name: string;
  sideName: string;
  PositionName: string = "";
  system: any;
  IsSystemImages:boolean=false;
  isInterp: boolean = false;
  constructor(private _dialogRef: MatDialogRef<ComponentImageHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any, private _dialog: MatDialog,) { }

  ngOnInit(): void {
    //this.equipmentId = this._data.equipmentID;
    //this.compartTypeId = this._data.comparttypeid;
    //this.side = this._data.side;
    //this.pos = this._data.position;
    //this.name = this._data.name;
    //this.isInterp = this._data.IsInterp;
    //if (this.side == 1) {
    //  this.sideName = "Left";
    //} else {
    //  this.sideName = "Right";
    //}

    //if (this.compartTypeId == 233) {
    //  if (this.pos == 1) {
    //    this.PositionName = "Front";
    //  } else {
    //    this.PositionName = "Rear";
    //  }
    //} else if (this.compartTypeId == 236 || this.compartTypeId == 234) {
    //  if (this.pos == 1) {
    //    this.PositionName = "Front";
    //  } else {
    //    this.PositionName = this.pos.toString();
    //  }
    //} else if (this.compartTypeId == 235) {
    //  this.PositionName = this.pos.toString();
    //}
    //if (!this._data.IsSystemImages) {
     
    //  this.GetComponenentImages();
    //} else {
    //   this.IsSystemImages=this._data.IsSystemImages;
    //  this.system = this._data.system;
    //  this.sideName= this.system?.Side==1?"Left":"Right";
    //  this.PositionName=this.system?.Type==1?"Chain":"Frame";
    //  this.GetSystemImages();
    //}

  }
//  ComponentImagesResponse: ComponentImagesResponse;
//  ComponentHistoryImages: ComponentHistoryImages[] = [];
//  groupedList: GroupedImages[] = [];
//  GetComponenentImages() {
//    this._interp.getComponentmages(this.equipmentId, this.compartTypeId, this.side, this.pos).subscribe(result => {
//      if (result.Status == 1) {
//        this.ComponentHistoryImages = result.Data;

//        const map = new Map<string, GroupedImages>();

//        for (const item of this.ComponentHistoryImages) {
//          const key = `${item.InspectionDate}_${item.SMU}`;
//          if (!map.has(key)) {
//            map.set(key, {
//              inspectionDate: item.InspectionDate,
//              smu: item.SMU,
//              images: [item.ImagePath],
//              wornpercentage: item.WornPercentage,
//              Comment: item.Comment
//            });
//          } else {
//            map.get(key)!.images.push(item.ImagePath);
//          }
//        }

//        this.groupedList = Array.from(map.values());
//      }
//    }, err => {

//    });
//  }

  onNoClick(): void {
    this._dialogRef.close(true);
  }

  openImagePopUp(Image: string){
    if(this.isInterp)
      this.openLargeImage(Image);
    else 
      this.OpenImage(Image);
  }

  OpenImage(Image: string) {
    const viewPhotoModalRef = this._dialog.open(ComponentImageDisplayComponent, {
      width: '630px',
      hasBackdrop: false,
      panelClass: ['custom-dialog-panel', 'multi-dialog'],
      data: {
        image: Image,
      }
    });
  }

//  GetSystemImages() {
//    this._interp.getSystemHistoricalImages(this.equipmentId,this.system?.Type, this.system?.Side).subscribe(result => {
//      if (result.Status == 1) {
//        this.ComponentHistoryImages = result.Data;

//        const map = new Map<string, GroupedImages>();

//        for (const item of this.ComponentHistoryImages) {
//          const key = `${item.InspectionDate}_${item.SMU}`;
//          if (!map.has(key)) {
//            map.set(key, {
//              inspectionDate: item.InspectionDate,
//              smu: item.SMU,
//              images: [item.ImagePath],
//              wornpercentage: item.WornPercentage,
//              Comment: item.Comment
//            });
//          } else {
//            map.get(key)!.images.push(item.ImagePath);
//          }
//        }

//        this.groupedList = Array.from(map.values());
//      }
//    }, err => {

//    });
//  }

    openLargeImage(base64Data: string): void {
    const imageBase64 = base64Data;

    const width = window.screen.availWidth;
    const height = window.screen.availHeight;

    const newWindow = window.open(
      "",
      "_blank",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`,
    );

    if (!newWindow) {
      alert("Popup blocked. Please allow popups for this website.");
      return;
    }

    newWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Image Viewer</title>

<style>

html,body{
    margin:0;
    width:100%;
    height:100%;
    overflow:hidden;
    background:#000;
    font-family:Arial,Helvetica,sans-serif;
}

.toolbar{
    position:fixed;
    top:12px;
    left:50%;
    transform:translateX(-50%);
    display:flex;
    align-items:center;
    justify-content:space-between;
    min-width:430px;
    padding:6px 8px;
    background:rgba(35,35,35,.92);
    border-radius:8px;
    box-shadow:0 4px 15px rgba(0,0,0,.45);
    z-index:9999;
}

.toolbar-left{
    display:flex;
    align-items:center;
    gap:6px;
}
.toolbar button{
    height:30px;
    min-width:30px;
    border:none;
    border-radius:4px;
    background:#1976d2;
    color:#fff;
    font-size:14px;
    font-weight:600;
    cursor:pointer;
    padding:0 8px;
    transition:.2s;
}

.toolbar button:hover{
    background:#1565c0;
}

.zoomText{
    color:#fff;
    min-width:46px;
    text-align:center;
    font-size:14px;
    font-weight:600;
}

.fit-btn{
    min-width:82px;
}

.close-btn{
    margin-left:12px;
    width:30px !important;
    min-width:30px !important;
    height:30px;
    padding:0 !important;
    background:#d32f2f !important;
    font-size:18px !important;
    font-weight:bold;
    line-height:30px;
}

.close-btn:hover{
    background:#b71c1c !important;
}

.viewer{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    overflow:hidden;
    cursor:grab;
}

.viewer:active{
    cursor:grabbing;
}

img{
    user-select:none;
    -webkit-user-drag:none;
    transform-origin:center center;
    transition:transform .08s linear;
    max-width:none;
    max-height:none;
}

</style>

</head>

<body>

<div class="toolbar">
    <div class="toolbar-left">
        <button id="zoomOut" title="Zoom Out">−</button>

        <span id="zoomValue" class="zoomText">125%</span>

        <button id="zoomIn" title="Zoom In">+</button>

        <button id="reset" title="Reset Zoom">125%</button>

        <button id="fit" class="fit-btn">Screen Fit</button>
    </div>

    <button class="close-btn" title="Close" onclick="window.close()">
        &#10005;
    </button>
</div>

<div class="viewer" id="viewer">
    <img id="img" src="${imageBase64}" draggable="false"/>
</div>

<script>

const img=document.getElementById('img');
const viewer=document.getElementById('viewer');
const zoomText=document.getElementById('zoomValue');

let scale=1.25;
let posX=0;
let posY=0;
let isDragging=false;
let startX=0;
let startY=0;

function updateImage(){

    img.style.transform =
        'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';

    zoomText.innerText = Math.round(scale * 100) + '%';

    viewer.style.cursor = canDrag() ? 'grab' : 'default';
}

updateImage();

document.getElementById('zoomIn').onclick=function(){
    scale = Math.min(scale + 0.1, 5);
    updateImage();
};

document.getElementById('zoomOut').onclick=function(){
    if(scale>0.2){
        scale = Math.max(scale - 0.1, 0.2);
        updateImage();
    }
};

document.getElementById('reset').onclick=function(){
    scale = 1.25;
    posX=0;
    posY=0;
    updateImage();
};

document.getElementById('fit').onclick=function(){

    const vw=viewer.clientWidth;
    const vh=viewer.clientHeight;

    const iw=img.naturalWidth;
    const ih=img.naturalHeight;

    scale = Math.min(vw / iw, vh / ih) * 0.95;

    posX=0;
    posY=0;

    updateImage();
};

function canDrag() {
    return true;
}

viewer.addEventListener('wheel',function(e){

    e.preventDefault();

    if(e.deltaY<0)
        scale+=0.1;
    else if(scale>0.2)
        scale-=0.1;

    updateImage();

},{passive:false});

viewer.addEventListener('mousedown', function (e) {

    if (!canDrag()) return;

    isDragging = true;

    startX = e.clientX - posX;
    startY = e.clientY - posY;

    viewer.style.cursor = 'grabbing';

    e.preventDefault();

});

window.addEventListener('mousemove',function(e){

    if(!isDragging) return;

    posX=e.clientX-startX;
    posY=e.clientY-startY;

    updateImage();

});

window.addEventListener('mouseup', function () {

    isDragging = false;

    viewer.style.cursor = canDrag() ? 'grab' : 'default';

});

</script>

</body>

</html>
`);

    newWindow.document.close();
    newWindow.focus();

    newWindow.moveTo(0, 0);
    newWindow.resizeTo(width, height);
  }

}
